import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

const CardContainer = (props) => {
  return (
    <AnimatePresence>
      <motion.div
        {...props}
        onHoverStart={() => {
          if (typeof props.onHoverStart === 'function') {
            return props.onHoverStart();
          }
        }}
        onHoverEnd={() => {
          if (typeof props.onHoverEnd === 'function') {
            return props.onHoverEnd();
          }
        }}
      >
        <div
          className={`relative border max-w-sm sm:w-96 h-56 mx-auto md:mx-0 ${
            !props.readonly && 'cursor-pointer'
          }`}
        >
          {props.children}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CardContainer;
